// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `
.product-detail[data-v-0f011232] {
  /* padding-bottom: 80px; */
}

/* 自定义按钮样式 */
[data-v-0f011232] .van-button--default {
  background-color: #f5f5f5;
  border-color: #e5e5e5;
  color: #666;
}
[data-v-0f011232] .van-button--primary {
  background-color: #ff7a00;
  border-color: #ff7a00;
}
[data-v-0f011232] .van-stepper {
  border: 1px solid #e5e5e5;
  border-radius: 8px;
  overflow: hidden;
}
[data-v-0f011232] .van-stepper {
  border: 0;
}
[data-v-0f011232] .van-popup {
  background: transparent;
}
[data-v-0f011232] .home-popup {
  left: 0;
  right: 0;
  /* width: 100%; */
  margin-inline: auto;
  /* padding-inline: 1rem; */
}
[data-v-0f011232] .van-overlay {
  display: none;
}
[data-v-0f011232] .van-search {
  background-color: transparent;
}
[data-v-0f011232] .van-search__content {
  background-color: transparent;
  padding-left: 0;
}
[data-v-0f011232] .van-field__left-icon {
  display: none;
}
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
